import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, List, Box, Flex, Avatar, Text } from "samba-ui";
import useDashboardFilters from "./hooks/useDashboardFilters";
import SetFilters from "./SetFilters";
import ShowPeriscopeUrl from "./ShowPeriscopeUrl";
import getPeriscopeUrlParams from "../utils/getPeriscopeUrlParams";

const UserSinglePeriscopeDashboard = ({
  periscopeDashboard,
  updateDashboardFilters,
  deleteDashboard
}) => {
  const { userDashboardId } = periscopeDashboard;
  const [showPeriscopeUrl, setShowPeriscopeUrl] = useState(null);
  const [disabledUpdateButton, setDisabledUpdateButton] = useState(true);
  const onUpdateClick = () => {
    const filterIds = filters.map(({ value }) => value);
    updateDashboardFilters(userDashboardId, dashboard.id, filterIds);
  };
  const onDeleteClick = () => {
    deleteDashboard(userDashboardId, dashboard.id);
  };

  const [dropDownOptions, dashboard, filters, setFilters] = useDashboardFilters(
    periscopeDashboard
  );

  const onSetSelectedFilters = filters => {
    setShowPeriscopeUrl(false);
    setFilters(filters);
    setDisabledUpdateButton(false);
  };
  const { logo, name, campaignTableId, campaignName } = dashboard;
  return (
    <List.Item borderColor="#d6d6d6 !important">
      <Flex alignItems="center" justifyContent="space-between">
        <Box width={1 / 6}>
          <Flex alignItems="center">
            <Avatar
              src={logo}
              mr={2}
              width={40}
              height={40}
              backgroundColor="white"
            />
            <Box>
              <Text fontSize={1} color="palette.ink.normal">
                {name}
              </Text>
            </Box>
          </Flex>
          <Flex flexDirection="column">
            <Box>
              <Text fontSize={1} fontWeight={500}>
                Campaign Id:
              </Text>
              <Text fontSize={1}> {campaignTableId}</Text>
            </Box>
            <Box>
              <Text fontSize={1} fontWeight={500}>
                Campaign name:
              </Text>
              <Text fontSize={1}> {campaignName}</Text>
            </Box>
          </Flex>
        </Box>
        {dropDownOptions && (
          <Box width={1 / 2}>
            <SetFilters
              filters={dropDownOptions}
              selectedFilters={filters}
              setSelectedFilters={onSetSelectedFilters}
            />
          </Box>
        )}

        <Flex width={1 / 4} alignItems="center" justifyContent="space-around">
          {showPeriscopeUrl ? (
            <ShowPeriscopeUrl
              {...getPeriscopeUrlParams(periscopeDashboard, filters)}
            />
          ) : (
            <Button
              variant="secondary"
              onClick={() => setShowPeriscopeUrl(true)}
            >
              Test Embedded Url
            </Button>
          )}
          <Button
            variant="primaryBordered"
            onClick={onUpdateClick}
            disabled={disabledUpdateButton}
          >
            Update
          </Button>
          <Button variant="destructiveBordered" onClick={onDeleteClick}>
            Delete
          </Button>
        </Flex>
      </Flex>
    </List.Item>
  );
};

UserSinglePeriscopeDashboard.propTypes = {
  periscopeDashboard: PropTypes.object,
  updateDashboardFilters: PropTypes.func,
  deleteDashboard: PropTypes.func
};

export default UserSinglePeriscopeDashboard;
